import api from "@/lib/api";

const CHUNK = 5 * 1024 * 1024;

// Resumable chunked upload. opts: { metadata, targetId, uploadId, onInit, onProgress }
export async function chunkedUpload(file, opts = {}) {
  const total = Math.ceil(file.size / CHUNK) || 1;
  let id = opts.uploadId;
  let received = [];

  if (!id) {
    const { data } = await api.post("/videos/upload/init", {
      filename: file.name, size: file.size,
      metadata: opts.metadata || {}, target_id: opts.targetId || null,
    });
    id = data.upload_id;
    opts.onInit?.(id);
  } else {
    try {
      const { data } = await api.get(`/videos/upload/${id}/status`);
      received = data.received || [];
    } catch { received = []; }
  }

  for (let i = 0; i < total; i++) {
    if (received.includes(i)) { opts.onProgress?.(Math.round(((i + 1) / total) * 100)); continue; }
    const blob = file.slice(i * CHUNK, i * CHUNK + CHUNK);
    await api.put(`/videos/upload/${id}/chunk/${i}`, blob, {
      headers: { "Content-Type": "application/octet-stream" },
    });
    opts.onProgress?.(Math.round(((i + 1) / total) * 100));
  }

  const { data } = await api.post(`/videos/upload/${id}/complete`, {
    total_chunks: total, target_id: opts.targetId || null, metadata: opts.metadata || null,
  });
  return { uploadId: id, video: data };
}
